import React, { useEffect } from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker, faPython } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';
import { trackSectionView } from '../utils/mixpanel';

const labelsFirst = [
    "Kotlin",
    "Java",
    "Swift",
    "Android",
    "IOS",
    "React Native",
    "SQL",
    "MVVM",
    "MVI",
    "Clean Architecture",
    "Postman"
];

const labelsSecond = [
    "Spring Boot",
    "Php",
    "Laravel",
    "Python",
    "Flask",
    "Git",
    "GitHub Actions",
    "Docker",
    "AWS",
    "Azure",
    "Linux",
    "Snowflake",
    "Pandas",
    "Selenium",
];

const labelsThird = [
    "OpenAI",
    "Groq",
    "LangChain",
    "Qdrant",
    "Hugging Face",
    "LlamaIndex",
    "Streamlit",
    "Computer Vision",
    "Augumented Reality",
    "AI",
    "Machine Learning",
];

function Expertise() {
    useEffect(() => {
        trackSectionView('expertise');
    }, []);

    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faReact} size="3x"/>
                    <h3>Mobile App Developement</h3>
                    <p>I have built a diverse array of mobile applications from scratch using modern technologies such as Native Android, Native iOS, and React Native. I have a strong proficiency in the mobile app development lifecycle (SDLC) and expertise in both frontend and backend development for mobile platforms.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDocker} size="3x"/>
                    <h3>Backend, DevOps & Automation</h3>
                    <p>Once the mobile application is built, I assist clients with DevOps testing, CI/CD pipelines, and deployment automation for a successful Go-Live. I also leverage my backend expertise in Spring Boot, PHP Laravel, and Python Flask to build robust backends supporting mobile apps.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faPython} size="3x"/>
                    <h3>GenAI, Computer Vision & LLM</h3>
                    <p>I leverage Generative AI, Computer Vision, and LLMs to develop intelligent solutions that enhance automation and decision-making. With expertise in enterprise-grade AI and AR-enabled technologies, I create impactful, real-world applications.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                
            </div>
        </div>
    </div>
    );
}

export default Expertise;